module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0b0662d4fa04471ec5b47ffd617bf5d3.png";